export default "__VITE_ASSET__DvsfjUau__"